<template>
  <!-- MODE CREATE / EDIT -->
  <ValidationProvider
      v-if="!viewMode"
      :name="label"
      :rules="rules || ''"
      v-slot="{ errors }"
  >
    <div class="mb-3">
      <label class="form-label">
        {{ label }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>

      <!-- TEXT -->
      <input
          v-if="type === 'text'"
          v-model="localValue"
          :disabled="disabled"
          class="form-control"
      />

      <!-- DATE -->
      <input
          v-else-if="type === 'date'"
          type="date"
          v-model="localValue"
          :disabled="disabled"
          class="form-control"
      />

      <!-- TEXTAREA -->
      <textarea
          v-else-if="type === 'textarea'"
          v-model="localValue"
          :disabled="disabled"
          class="form-control"
      />

      <!-- SELECT NATIF -->
      <select
          v-else-if="type === 'select'"
          v-model="localValue"
          :disabled="disabled"
          class="form-select"
      >
        <option value="">-- Sélectionner --</option>
        <option
            v-for="opt in options"
            :key="opt[valueKey]"
            :value="opt[valueKey]"
        >
          {{ opt[labelKey] }}
        </option>
      </select>

      <small class="text-danger">{{ errors[0] }}</small>
    </div>
  </ValidationProvider>

  <!-- MODE VIEW -->
  <div v-else class="mb-3">
    <label class="form-label">
      {{ label }}
      <span v-if="isRequired" class="text-danger">*</span>
    </label>

    <div class="form-control-plaintext fw-semibold">
      {{ displayValue }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FieldViewEdit',
    props: {
      value: [String, Number],
      label: String,
      type: {
        type: String,
        default: 'text', // text | textarea | date | select
      },
      rules: String,
      viewMode: Boolean,
      disabled: Boolean,
      required: Boolean,

      /* SELECT */
      options: {
        type: Array,
        default: () => [],
      },
      valueKey: {
        type: String,
        default: 'id',
      },
      labelKey: {
        type: String,
        default: 'label',
      },
    },

    computed: {
      localValue: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },

      isRequired() {
        return (
            this.required === true ||
            (this.rules && this.rules.includes('required'))
        );
      },

      displayValue() {
        if (!this.value) return '-';

        if (this.type === 'select') {
          const found = this.options.find(
              o => String(o[this.valueKey]) === String(this.value)
          );
          return found ? found[this.labelKey] : this.value;
        }

        return this.value;
      },
    },
  };
</script>
